import {h, Component} from 'preact';

/*https://icons8.com/cssload/en/horizontal-bars*/
export default class DefaultProfileImage extends Component {
    render() {
        return (
            <svg
                id="Layer_1" data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                    <title>ClientChat_ProfilePic_DynamicColour</title>
                    <path
                    style={{fill: this.props.color}}

                    d="M17.49,20.58l-1.59.14a1.69,1.69,0,0,0-1.53,1.83l.76,8.65A1.69,1.69,0,0,0,17,32.73l2.17-.19a1.68,1.68,0,0,0,1.42-1.1,12.22,12.22,0,0,0,2.7,4A11.94,11.94,0,0,0,32,39l-6.82,6.15,4.7,18.72c.71,0,1.43.08,2.15.08s1.44,0,2.16-.08l4.71-18.72L32.05,39a11.94,11.94,0,0,0,8.74-3.61,12.21,12.21,0,0,0,2.68-3.94,1.69,1.69,0,0,0,1.45,1.15H45c-.38,1.63-1.88,3.81-2.95,5.43a1.33,1.33,0,0,0-1,.49l-1.65,1.86a1.49,1.49,0,0,0,0,2.2c.66.43,1.54.87,2.1.21L43.13,41a1.93,1.93,0,0,0,.35-1.67c1.36-2,3-4.58,3.43-6.52l.19,0a1.69,1.69,0,0,0,1.83-1.53l.76-8.65a1.69,1.69,0,0,0-1.53-1.83l-1.61-.14C44.76,9,35,8,31.74,8,27.78,8,19.11,9.37,17.49,20.58ZM44,23.45a12.36,12.36,0,0,0-12-9.18,12.36,12.36,0,0,0-12,9.2c.38-11,7.44-12.66,11.7-12.66C36.2,10.81,43.56,12.51,44,23.45Z"/>
                    <path
                    style={{fill: this.props.color}}
                    d="M7.53,52A31,31,0,0,0,28.88,63.83L17.77,41a10.61,10.61,0,0,0-3.26,1.4A13.32,13.32,0,0,0,10.46,46a17.85,17.85,0,0,0-2.74,5.32C7.64,51.54,7.59,51.77,7.53,52Z"/>
                    <path
                    style={{fill: this.props.color}}
                    d="M56.72,51.32A17.86,17.86,0,0,0,54,46a13.33,13.33,0,0,0-4.06-3.59A10.33,11.33,0,0,0,46.3,41L35.15,63.83A31,31,0,0,0,56.8,51.6C56.77,51.51,56.75,51.42,56.72,51.32Z"/>
            </svg>
        );
    }
}



// WEBPACK FOOTER //
// ./components/DefaultProfileImage.js